import { Component, OnInit, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { GenesisUnitOfWork } from '../../core/core.module';
import _ from 'lodash';
import { confirm, alert } from 'devextreme/ui/dialog';


@Component({
    selector: 'app-list-dialog',
    templateUrl: './list-dialog.component.html',
    styleUrls: ['./list-dialog.component.scss'],
    standalone: false
})
export class ListDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    dialogHeader = 'List';
    dialogSaveText = 'Save';
    newValue: any;
    values: any;
    emailFormat = false;

    async ngOnInit() {
        this.setValuesFromDefaultValuesCsv();
        await Promise.resolve(null);
    }

    setValuesFromDefaultValuesCsv() {
            this.values = [];
    }

    addValue() {
        if (!!this.newValue && this.values.indexOf(this.newValue) === -1) {
            if (!this.valid()) return;
            this.values.push(this.newValue);
            this.values = _(this.values)
                .sortBy('')
                .value();
            this.newValue = '';
        }
    }

    valid() {
        let message = '';

        // if (this.minimumItems && this.values.length < this.minimumItems) {
        //     message = `${message}At least ${this.minimumItems} value${this.minimumItems > 1 ? 's' : ''} required.<br/>`;
        // }

        // if (this.maximumItems && this.values.length > this.maximumItems) {
        //     message = `${message}At most ${this.maximumItems} part type${this.maximumItems > 1 ? 's' : ''} can be selected.<br/>`;
        // }

        if (message.length > 0) {
            alert(message, 'Validation Error');
            return false;
        } else return true;
    }

    save() {
        if (this.valid()) {
            const csvValues = this.values.join(',');
            this.result.next({ result: true, value: csvValues });
        }
    }

    cancel() {
        this.result.next({ result: false });
    }
}
